var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 28 29"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.972 0c-7.146 0-6.7 3.099-6.7 3.099l.009 3.21h6.818v.964H4.572S0 6.754 0 13.963c0 7.21 3.99 6.955 3.99 6.955h2.383v-3.346s-.129-3.99 3.927-3.99h6.762s3.8.06 3.8-3.673V3.736S21.44 0 13.972 0Zm-3.76 2.159a1.226 1.226 0 1 1 0 2.453 1.226 1.226 0 1 1 0-2.453Z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.174 28c7.145 0 6.7-3.099 6.7-3.099l-.009-3.21h-6.818v-.964h9.527s4.572.519 4.572-6.69c0-7.21-3.99-6.955-3.99-6.955h-2.383v3.346s.129 3.99-3.927 3.99h-6.763s-3.8-.06-3.8 3.673v6.173S6.708 28 14.175 28Zm3.76-2.159a1.226 1.226 0 1 1 0-2.453 1.226 1.226 0 1 1 0 2.453Z",
    fill: "url(#b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 2.705,
    y1: 2.447,
    x2: 16.623,
    y2: 16.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387EB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#366994"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 11.266,
    y1: 11.331,
    x2: 26.213,
    y2: 25.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC331"
  })))));
};
export default __webpack_public_path__ + "static/media/python.5d6913a5.svg";
export { SvgComponent as ReactComponent };